import { useQuery } from '@tanstack/react-query';
import { useMemo } from 'react';

import { _getFiles } from '@/api/files/queries';
import type { File } from '@/api/files/types';

export function useFilesById(fileIds: (string | undefined | null)[]): Record<string, File> {
  const ids = useMemo(() => fileIds.filter((id): id is string => !!id), [fileIds]);

  const { data } = useQuery(_getFiles(ids, { include: 'url' }));

  return useMemo(() => {
    const map: Record<string, File> = {};
    data?.files.forEach((file) => {
      map[file.id] = file;
    });
    return map;
  }, [data?.files]);
}
